import type { IModalText } from "app/components/sharingAssetModal/types";
import { ESharingState } from "app/components/sharingAssetModal/types";
import type { ICategory } from "app/common/services/categoryService.types";
import { i18nFilter } from "app/filters/i18nFilter";
import { commonKeys } from "app/components/sharingAssetModal/commonKeys";

export const getModalText = (customIndustry: ICategory): IModalText => {
    const { text: industryName } = customIndustry;
    const i18n = i18nFilter();
    return {
        header: {
            title: i18n("shared.custom.industries.modal.title"),
            subtitle: industryName,
        },
        sharingStateContainer: {
            [ESharingState.PRIVATE]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.PRIVATE].title),
                subtitle: i18n("shared.custom.industries.modal.options.private.subtitle"),
            },
            [ESharingState.ACCOUNT]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.ACCOUNT].title),
                subtitle: i18n("shared.custom.industries.modal.options.account.subtitle"),
            },
            [ESharingState.SUBSET_OF_USERS]: {
                title: i18n(commonKeys.sharingStateContainer[ESharingState.SUBSET_OF_USERS].title),
                subtitle: i18n("shared.custom.industries.modal.options.users.subtitle"),
                notificationDefaultContent: `Hi there,
I would like to share the ${industryName} custom industry with you. 
Take a look!`,
            },
        },
        disabledStatesBannerKey: "shared.custom.industries.modal.disable.due.segments",
    };
};
